<template>
  <div class="a-timeline">
    <a-timeline class="timeline" pending="Recording...">
      <a-timeline-item
        v-for="(item, idx) in timelineMilestones"
        :key="item.date + '-' + idx"
      >
        <div class="span1" style="font-size: 18px">{{ item.date }}</div>
        <div class="span3">{{ item.text }}</div>
      </a-timeline-item>
    </a-timeline>
  </div>
</template>

<script>
import { timelineMilestones } from "@/data/timelineMilestones";

export default {
  data() {
    return {
      timelineMilestones,
    };
  },
};
</script>
<style scoped lang="less">
.a-timeline {
  width: 100%;
  position: relative;
  top: 64px;
  .timeline {
    width: 1200px;
    margin: 60px auto;
    /deep/.ant-timeline-item-content {
      .span1 {
        font-size: 24xp !important;
        line-height: 32px;
      }
      .span2 {
        font-size: 32xp !important;
        line-height: 40px;
      }
      .span3 {
        font-size: 26xp !important;
        line-height: 34px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/timeLine.vue